import React, {useEffect, useState} from 'react';
import {
  IGenericType,
  ISupplierCompanyProfile,
  ISupplierUserProfile,
} from 'constants/interfaces';
import {CompanyForm} from 'components/CompanyForm/CompanyForm';
import {CompanyPermissionsForm} from 'components/CompanyForm/CompanyPermissionsForm';
import {
  apiGetBankAccountTypes,
  apiGetBankTypes,
  apiUpdateCompany,
} from 'constants/Api';
import {PermissionsService} from 'services/PermissionsService';
import {ESupplierUserPermissions} from 'constants/index';
import {Box, Typography} from '@material-ui/core';

export function AddOrUpdateCompany(props: {
  user: ISupplierUserProfile;
  company?: ISupplierCompanyProfile;
  onUpdate: () => any;
  companyTab?: boolean;
}) {
  const permissions = new PermissionsService(props.user);
  const canWrite = permissions.hasPermission(
    ESupplierUserPermissions.COMPANY_WRITE,
  );

  const [isLoading, setIsLoading] = useState(false);

  const [isLoadingBankInfo, setIsLoadingBankInfo] = useState(true);
  const [bankTypes, setBankTypes] = useState<IGenericType[]>([]);
  const [bankAccountTypes, setBankAccountTypes] = useState<IGenericType[]>([]);

  useEffect(() => {
    setIsLoadingBankInfo(true);
    apiGetBankTypes()
      .then(setBankTypes)
      .then(apiGetBankAccountTypes)
      .then(setBankAccountTypes)
      .catch((error) => {
        alert('Failed to load bank information. Please try again later');
        console.error(error);
      })
      .finally(() => setIsLoadingBankInfo(false));
  }, [props.user]);

  const handleSubmit = (company: ISupplierCompanyProfile) => {
    if (!canWrite) return;
    setIsLoading(true);
    apiUpdateCompany({
      ...company,
      id: undefined,
      companyId: company.id,
      mainSupplierId: props.user.mainSupplier?.id || '',
      brandSupplierId: props.user.brand?.id || '',
    })
      .then(props.onUpdate)
      .catch((err) => {
        alert('Failed to update company at the moment. Please try again later');
        console.error('Failed to update company', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="form-outer-container company-profile-form-shell">
      <CompanyForm
        user={props.user}
        company={props.company}
        isLoading={isLoading}
        submitButtonTitle={'Update'}
        onSubmit={handleSubmit}
        readonly={!canWrite}
        isLoadingBankInfo={isLoadingBankInfo}
        bankTypes={bankTypes}
        bankAccountTypes={bankAccountTypes}
      />
      {props.companyTab && (
        <Box mt={4}>
          <Typography variant="h6" gutterBottom>
            Company Permissions
          </Typography>
          <CompanyPermissionsForm
            companyPermissions={props.user.companyPermissions}
            isLoading={isLoading}
            submitButtonTitle={'Update'}
            onSubmit={() => {}}
            readonly={true}
            smallWidth={false}
          />
        </Box>
      )}
    </div>
  );
}
